import React from "react";
import TeamDetails from "./Containers/TeamDetailsContainer";

class TeamDetailsPage extends React.PureComponent {

    componentWillUpdate(nextProps) {
        this._handleLoad(nextProps)
    }

    componentWillMount() {
        this._handleLoad(this.props)
    }

    _handleLoad(props) {
        if (props.loading) {
            return;
        }

        if (!props.team || props.team.id !== Number(props.match.params.teamId)) {
            this.props.onLoad(props.match.params.game, props.match.params.teamId);
        }
    }


    render() {
        if (this.props.loading) {
            return <div className="alert alert-info">Loading...</div>
        }
        return <TeamDetails/>
    }
}

export default TeamDetailsPage